<template>
  <!--创建EXT跟grid配对的按钮-->
  <el-dialog
    :title="$t('lang.addvideo')"
    :visible.sync="data.show"
    width="600px"
    :center="true"
    :close-on-click-modal="false"
    class="add-source-dialog uploadDate"
    :before-close="cancelUploadedVideo"
    :destroy-on-close="true"
  >
    <div class="content">
      <el-row>
        <el-col>
          <p class="item_title">
            <span>*</span>
            {{ $t("lang.Folder") }}
          </p>
          <el-input
            class="treeInput"
            suffix-icon="arrow-icon el-icon-arrow-top"
            v-model="flodLocation"
            @focus="showTree"
            readonly="readonly"
            :placeholder="$t('lang.selectFolder')"
            :disabled="fileList.length > 0"
          ></el-input>
          <div
            class="flodTree"
            v-if="showTreeFlag">
            <el-tree
              :data="mediaList"
              :props="mediaListProps"
              node-key="id"
              default-expand-all
              show-checkbox
              :expand-on-click-node="false"
              :check-on-click-node="true"
              ref="tree"
              :check-strictly="true"
              @check="getCheckedKeys"
            >
              <span
                class="custom-tree-node"
                slot-scope="{ node, data }"
              >
                <span
                  class="f_left ellipsis"
                  :title="node.label">
                  <span
                    class="iconfont icon-Handle f_left ellipsis"
                    style="color: #33ab4f"
                    v-if="data.folderName ? true : false"
                  ></span>
                  {{ node.label }}
                </span>
              </span>
            </el-tree>
          </div>
        </el-col>
        <el-col
          class="CoverWrap">
          <div class="upload_p">
            <el-upload
              ref="loadControl"
              class="upload"
              action="#"
              :multiple="true"
              :show-file-list="false"
              :disabled="flodLocation == ''"
              accept=".ts,.rm,.rmvb,.wmv,.wtv,.avi,.3gp,.mkv,.mpg,video/mpeg,video/mp4,.mov,.mxf,.json,.tvu,.mp3,.aac"
              :http-request="uploadFileBySDK"
            >
              <el-button size="small" :disabled="flodLocation == ''" type="primary" :loading='uploadLoading'>{{ $t("lang.upload") }}</el-button>
            </el-upload>
            <div
              class="videoList"
            >
              <div class="uploadMessage" v-for="(item, index) in fileList" :key="index + item.name + item.uid">
                <div class="uploadStatus">
                  <div class="name" :style="{color: item.status == 'success'? '#DBDBDB': '#666666'}">
                    <i class="iconfont icon-video1"></i><span>{{item.name}}</span>
                  </div>
                  <div class="Status">
                    <i v-if="item.status == 'success'" class="el-icon-success"></i>
                    <i v-if="item.status == 'upload'" class="el-icon-close" @click="cancelVideo(item, index)"></i>
                  </div>
                </div>
                <el-progress v-if="item.status != 'success'" :stroke-width="4" :percentage="item.percentage"></el-progress>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>
<script>
/*
 * 上傳视频本地测试有两处地址需要修改
 * 2.在UploadVideoForm.vue中将href字段修改
 * 以上都有注释 想要本地上传亚马逊测试的自我查看
 *
 * 上传亚马逊的基本思路为
 * ***
 * 1.调用后端接口,获取需要上传到亚马逊的数据(从后台获取亚马逊需要的数据)
 * 2.提交数据到亚马逊之后,亚马逊会自动刷新当前form表单的页面,刷新后 将form表单所在页面的url改变,将我们需要的字段通过url返回给我们
 * (后台通过这些字段可以找到当前上传视频所在亚马逊的位置及视频信息)
 * 3.获取到url中的信息后 将获取信息通过接口发送给后端 完成上传
 *
 * */
import AWS from 'aws-sdk'
import Bus from '@/assets/js/vueBus.js'
import { mapState } from 'vuex'
import { playoutAnalyze } from '@/assets/js/googleAnalyze/playout.js'
import toTips from '@/assets/js/toTipsObj'
import Outil from '@/assets/js/utils.js'
import commonRequest from '@/assets/js/common/commonRequest.js'
export default {
  props: {
    data: Object,
    edit: Boolean,
    editData: Object,
    session: String
  },
  computed: mapState({
    State: (state) => state,
    pageRequest: (state) => state.websocket.pageRequest
  }),
  data () {
    return {
      // 视频文件列表配置
      mediaListProps: {
        label: 'name',
        children: 'sonFileInfo'
      },
      awsInfo: {},
      canAdd: false,
      floderList: [],
      fileParam: {
        pageNum: 1,
        pageSize: 15,
        condition: '',
        sessionId: Outil.getSession()
      },
      times: '',
      uploadingFile: null,
      // 文件上传列表
      fileList: [
      ],
      floderLocalName: '',
      uploadObj: {},
      fileId: '',
      loadFlag: false,
      objctKey: {},
      flodLocation: '',
      showTreeFlag: false,
      mediaList: [],
      queryRgion: true,
      // 拥有者OwnerUserid
      OwnerUserid: '',
      // 是否上传成功
      IsUploadSuccess: false,
      // 上传视频预览封面
      coverImg: '',
      uploadLoading: false
    }
  },
  created () {
    const awsInfo = this.$BehaviorSyns.getRegionBucket()
    this.awsInfo = Object.assign({}, awsInfo)
  },
  mounted () {
    document.addEventListener('click', this.clickFolderSelect)
    this.objctKey.id = this.data.parentId
  },
  methods: {
    // 点击文件夹外
    clickFolderSelect (event) {
      if (
        !(
          $('.flodTree')[0] == event.target ||
          ($('.flodTree')[0] && $('.flodTree')[0].contains(event.target)) ||
          $('.treeInput')[0] == event.target ||
          ($('.treeInput')[0] && $('.treeInput')[0].contains(event.target))
        )
      ) {
        this.showTreeFlag = false
      }
    },
    showTree () {
      this.showTreeFlag = true
      this.showList()
    },
    // 点击复选框时
    getCheckedKeys (current, checked) {
      let isChoose = false
      checked.checkedKeys.forEach((item) => {
        if (item != current.id) {
          this.$refs.tree.setChecked(item, false)
        } else {
          isChoose = true
        }
      })
      if (isChoose) {
        this.flodLocation = current.name
        this.objctKey = current
      } else {
        this.flodLocation = ''
        this.objctKey = {}
      }
      this.showTreeFlag = false
    },
    showList () {
      const programId = this.$BehaviorSyns.getProgramId()
      if (!programId) {
        return
      }
      const url = '/gatewayPlayoutUrl/tvu-playout/playoutfolderNew/getFolders'
      const fileParam = {
        pageNum: 1,
        pageSize: 1000,
        bucketCode: this.awsInfo.bucket,
        queryRgion: true,
        programId: programId,
        all: false
      }
      this.axios.post(url, fileParam, {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result.length > 0) {
            const folderList = res.data.result
            // const folderList = this.FilterFolder(res.data.result)
            const filterList = folderList.filter((item) => !item.fileFrom)
            this.mediaList = filterList
            this.$nextTick(() => {
              this.$refs.tree.setChecked(this.objctKey.id, true)
            })
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    // 过滤文件夹
    FilterFolder (folderList) {
      let FileList = []
      const ProgramRMessage = Outil.getProgramReceiver()
      let showFolders
      if (ProgramRMessage) {
        showFolders = ProgramRMessage.showFolders
      }
      if (showFolders) {
        showFolders = showFolders.toUpperCase()
        const folderNameList = showFolders.split(',')
        // 筛选要显示的文件夹
        FileList = folderList.filter((item) => folderNameList.includes(item.name.toUpperCase()))
        return FileList
      }
      const { urlInfo } = JSON.parse(localStorage.getItem('channelInitConfig'))
      if (urlInfo.folderNameList) {
        const folderName = urlInfo.folderNameList.toUpperCase()
        const folderNameList = folderName.split(',')
        // 筛选要显示的文件夹
        FileList = folderList.filter((item) => folderNameList.includes(item.name.toUpperCase()))
      }
      return FileList
    },
    // 获取视频长度
    getVideoTimeNew () {
      const file = this.uploadingFile.raw
      const video = document.createElement('video')
      video.preload = 'metadata'
      video.onloadedmetadata = () => {
        let url = video.src
        if (url.startsWith('blob:')) {
          url = url.substr(5)
        }
        window.URL.revokeObjectURL(url)
        const { duration } = video
        console.log(`视频长度为：${duration}`)
        this.times = video.duration
        this.canAdd = true
      }
      video.src = URL.createObjectURL(file)
      this.coverImg = video.src
    },
    selectClass (i) {
      if (i == 'clip') {
        return 'yellow'
      } else {
        return 'zise'
      }
    },
    async uploadFileBySDK (file) {
      const FileObject = {
        name: file.file.name,
        percentage: 0,
        raw: file.file,
        uid: file.file.uid,
        status: 'upload',
        data: null
      }
      this.fileList.push(FileObject)
      this.OwnerUserid = Outil.getProgramReceiver('ownerUserId')
      const params = {
        region: this.awsInfo.region,
        service: this.awsInfo.ServerName,
        bucketId: this.awsInfo.bucketId,
        directoryName: this.objctKey.objectKey
          ? this.objctKey.objectKey
          : `/${this.floderLocalName}`,
        fileName: FileObject.name,
        userId: this.OwnerUserid
      }
      const ContentType = file.file.type ? file.file.type : null
      this.uploadLoading = true
      this.$http
        .post('/file/request-upload-for-sdk', params, {
          requestBase: 'GATEWAY'
        })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            const { result } = res.data
            AWS.config.region = result.identityPoolRegion
            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
              IdentityPoolId: result.identityPoolId
            })
            this.doUploadFile(result, FileObject, ContentType)
            this.uploadLoading = false
          }
        }).catch(() => {})
    },
    doUploadFile (obj, FileObject, ContentType) {
      FileObject.data = new AWS.S3.ManagedUpload({
        params: {
          Bucket: obj.bucket,
          Key: obj.objectKey,
          Body: FileObject.raw,
          ACL: 'public-read', // 固定
          ContentType
        },
        service: new AWS.S3({
          region: obj.region
        })
      })
      FileObject.data.on('httpUploadProgress', (event) => {
        FileObject.percentage = Math.floor(
          (event.loaded * 100) / event.total
        )
        if (FileObject.percentage == 100) {
          FileObject.percentage = 99
        }
      })
      FileObject.data.promise().then((data) => {
        this.saveResult(obj, FileObject)
      })
    },
    saveResult (obj, FileObject) {
      const params = {
        bucketId: obj.bucketId,
        directoryId: obj.directoryId,
        objectKey: obj.objectKey
      }
      this.axios
        .post('/file/add-file', params, { requestBase: 'GATEWAY' })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            FileObject.percentage = 100
            FileObject.status = 'success'
          } else {
            FileObject.status = 'failed'
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
    },
    // 取消视频上传
    cancelVideo (item, index) {
      if (item.status == 'upload') {
        item.data && item.data.abort()
        this.fileList.splice(index, 1)
      }
    },
    // 取消文件上传
    cancelUploadedVideo (done) {
      let AllUpload = true
      let UploadNumber = 0
      this.fileList.forEach(item => {
        if (item.status == 'upload') {
          AllUpload = false
        }
        if (item.status == 'success') {
          UploadNumber++
        }
      })
      if (!AllUpload) {
        this.$confirm(this.$t('lang.CancelUpload'), '', {
          confirmButtonText: this.$t('lang.Confirm'),
          cancelButtonText: this.$t('lang.cancel'),
          type: ''
        }).then(() => {
          this.fileList.forEach((item) => {
            if (item.status == 'upload') {
              item.data.abort()
            }
          })
          if (UploadNumber) {
            this.$emit('queryList', 'add', {
              Folder: this.objctKey.id,
              UploadNumber: UploadNumber
            })
          }
          done()
        }).catch(() => {})
      } else {
        if (UploadNumber) {
          this.$emit('queryList', 'add', {
            Folder: this.objctKey.id,
            UploadNumber: UploadNumber
          })
        }
        done()
      }
    }
  },
  beforeDestroy () {
    document.removeEventListener('click', this.clickFolderSelect)
  }
}
</script>
<style lang="less" scoped>
.CoverWrap {
  position: relative;
  margin-top: 20px;
  .upload{
    margin-bottom: 15px;
  }
  ::v-deep .videoList {
    width: 100%;
    max-height: 230px;
    min-height: 100px;
    overflow: auto;
    margin-bottom: 5px;
    .uploadMessage{
      margin-bottom: 10px;
      .uploadStatus{
        display: flex;
        justify-content: space-between;
        span{
          margin-left: 10px;
          font-size: 12px;
        }
        .el-icon-success{
          color: #39aa50;
        }
        .el-icon-close{
          display: none;
        }
      }
    }
    .el-progress {
      .el-progress__text {
        position: absolute;
        right: 0px;
        top: -15px;
        font-size: 18px;
        color: #fff;
      }
      .el-progress-bar{
        padding-right: 0px;
      }
    }
    .uploadMessage:hover .el-icon-close{
      display: inline-block;
    }
    .uploadMessage:hover .el-progress__text{
      display: none;
    }
  }
}

.item_title {
  font-size: 14px;
  font-weight: 400;
  color: rgba(223, 223, 223, 1);
  margin-bottom: 5px;

  span {
    color: red;
  }
}

.add-source-dialog {
  .content {
    text-align: left;
    font-size: 16px;
    max-height: 55vh;
    // overflow-y: auto;

    .item {
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }

      span {
        display: block;
        margin-bottom: 5px;
      }
    }

    ::v-deep .el-input .el-input__inner {
      border: 1px solid #444;
      background: #444;
      color: white !important;

      &::-webkit-input-placeholder {
        color: #666;
      }
    }

    ::v-deep .select-box {
      width: 100%;

      .el-input__inner {
        border: 1px solid #444;
        background: #444;
      }
    }

    ::v-deep .el-select {
      width: 100%;

      .el-select__input {
        color: #fff;
      }
    }

    ::v-deep .selectRlist {
      width: 100%;
      height: 300px;
      overflow-y: auto;
    }
  }
}

.flodTree {
  width: 510px;
  height: 190px;
  background: #444;
  position: absolute;
  z-index: 9999;
  border-radius: 2px;
  overflow-y: auto;
  margin-top: 5px;
  ::v-deep .el-tree{
    overflow: hidden;
  }
  ::v-deep .el-tree-node__content > .el-tree-node__expand-icon {
    padding: 1px;
  }
  ::v-deep .el-tree-node__content {
    height: 30px;
    line-height: 30px;
  }
  ::v-deep .el-checkbox {
    margin-bottom: 0px !important;
    margin-right: 5px !important;
  }
}
</style>
